const ZIPCODE_REGEXP = /[0-9]{7}/
const NUM_REGEXP = /[0-9]/

export const isValidZipCode = (zipcode: string): boolean => {
  if (!zipcode) {
    return false
  }
  if (!NUM_REGEXP.test(zipcode)) {
    return false
  }
  return ZIPCODE_REGEXP.test(zipcode)
}
